import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISavedFilter } from '../../types/vehicle';

export interface FilterSlice {
  appliedFilter?: ISavedFilter;
  savedFiltersRefesher: boolean;
}

const initialState: FilterSlice = {
  appliedFilter: undefined,
  savedFiltersRefesher: false,
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    pushAppliedFilter: (state, action: PayloadAction<ISavedFilter | undefined>) => {
      state.appliedFilter = action.payload;
    },
    refreshSavedFilters: (state, action: PayloadAction<boolean>) => {
      state.savedFiltersRefesher = action.payload;
    },
    setColumns: (state, action: PayloadAction<string[]>) => {
      if (state.appliedFilter) {
        state.appliedFilter.columns = action.payload;
      }
    },
  },
});

export const { pushAppliedFilter, refreshSavedFilters, setColumns } = filterSlice.actions;
export default filterSlice.reducer;
